import { render, staticRenderFns } from "./ListLokasi.vue?vue&type=template&id=ccab99ba"
import script from "./ListLokasi.vue?vue&type=script&lang=js"
export * from "./ListLokasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports